import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';

/*
This file is used to initialize the MSAL instance for Azure AD authentication.
We do this here instead of in index.tsx because we need to use the msalInstance
in the api/helpers.ts file and we don't want to import the msalInstance into that
file because it causes a circular dependency, which breaks Vite HMR and causes other issues.
*/

export const msalInstance = new PublicClientApplication(msalConfig);
